import { Col } from 'react-bootstrap';
import React from 'react';

import { ExampleCardPersonBlue } from '../TestimonialsComponent.component';
import {
  AfiyaMaritzaImages,
  AkmiliaAswariniImages,
  AnnisaRWardhaniImages,
  AnnisaSBaskaraImages,
  AyuDewilestariNapitupuluImages,
  BeatrixMarendengImages,
  FachriAkbarImages,
  FandiAfianataDarmawanImages,
  KathyAiraSuronoImages,
  LodangJatiImages,
  MuhammadHafizhAsadImages,
  MutiaSekarDiniImages,
  NahlaJovialImages,
  PutriAyuditaImages,
  RifkaCharmelitaImages,
  SerliKusumadewiImages,
  SitiKarinThaliaImages,
  SyahzamiPutraImages,
  ThantowySyamsuddinImages
} from '../../../../Assets/Images/testimonials';

export const PutriAyudita = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Program Academic Writing dari INGGO sangat terstruktur, logis, dan fokus kepada skill siswa yang butuh diperbaiki. Metode pembelajaran seperti idea structuring dan paraphrasing sangat cocok untuk yang sedang mengambil S2. Tutor saya sangat flexible walaupun ada perbedaan waktu antara Indonesia dan Belanda. Aku ngerasa terbantu banget karena sempat kesulitan lulus salah satu mata kuliah karena keterbatasan linguistik untuk membangun argumen di law examku dan dengan bantuan tutorku, akhirnya aku bisa lulus dan mendapat gelar Masters of Law. Aku sangat merekomendasikan INGGO untuk program Academic Writing."
      person="Putri Ayudita"
      source="Master of Law, University of Amsterdam"
      images={PutriAyuditaImages}
      programs="Academic Writing"
    />
  </Col>
);

export const NahlaJovial = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Sebelum les di INGGO, saya sudah les IELTS dimana-mana menghabiskan berjuta-juta yang mungkin hingga sampai puluhan, bahkan hingga di lembaga yang terkenal dengan pengajar native speaker. Namun setelah belajar dengan INGGO, kemampuan IELTS saya meningkat pesat. Setelah saya kuliah, saya mengikuti program Academic Writing yang sangat membantu saya memahami cara penulisan yang kritis. Sukses selalu buat INGGO!"
      person="Nahla Jovial"
      source="Master of Arts in Social Policy for Development, Erasmus University of Rotterdam"
      images={NahlaJovialImages}
      programs="IELTS & Academic Writing"
    />
  </Col>
);

export const BeatrixMarendeng = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Bimbingan Academic Writing dari INGGO benar-benar membantu saya menghadapi tantangan selama berkuliah di luar negeri. Karena saya tidak pernah mendapatkan ilmu tentang academic writing, saya sangat butuh bimbingan yang hanya bisa saya percayakan kepada INGGO. Selama bimbingan, tutor saya benar-benar tahu kebutuhan saya. Bimbingannya juga menggunakan metode yang sangat sederhana dan mudah saya ikuti dan pahami. Alhasil nilai tugas saya yang pertama adalah “Pass with Distinction!” Can’t thank you enough, INGGO!"
      person="Beatrix Marendeng"
      source="Master of Public Health, University of Glasgow"
      images={BeatrixMarendengImages}
      programs="Academic Writing"
    />
  </Col>
);

export const SyahzamiPutra = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="INGGO banyak berjasa kepada saya dalam proses persiapan sekolah hingga proses kuliah saya sekarang. Saya berhutang budi kepada para pengajar di INGGO karena berhasil mengantarkan saya meraih nilai IELTS yang saya butuhkan untuk meraih beasiswa dan kuliah di Jepang. Selain itu saya mendapatkan bekal Academic Writing juga sehingga saya dapat meraih nilai yang sangat baik selama saya kuliah. Saya selalu merekomendasikan INGGO kepada rekan kantor saya dan teman-teman lainnya yang ingin persiapan sekolah ke luar negeri, konsultasi, IELTS, maupun kursus Academic Writing yang sangat dibutuhkan dalam pembuatan paper, tugas, maupun tesis."
      person="Syahzami Putra"
      source="Master of Law, Kobe University"
      images={SyahzamiPutraImages}
      programs="IELTS & Academic Writing"
    />
  </Col>
);

export const AkmiliaAswarini = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Setelah mengikuti kelas Business English di INGGO, saya jadi lebih mengerti dan dapat berbicara dalam Bahasa Inggris dengan lebih baik. Hal yang paling saya rasakan adalah saya menjadi lebih baik ketika menulis email atau laporan dalam bahasa Inggris. Selain itu, yang diajarkan tidak hanya terkait Bahasa tapi juga do's and don'ts saat berinteraksi dengan rekan bisnis. Tutor saya juga sangat baik dan mendengar kebutuhan saya. Saya sudah top-up beberapa kali karena selalu ada insight baru yang saya dapat dari setiap sesi. Saya sangat merekomendasikan INGGO kepada teman-teman saya!"
      person="Akmilia Aswarini"
      images={AkmiliaAswariniImages}
      programs="Business English"
    />
  </Col>
);

export const AyuDewilestariNapitupulu = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="INGGO adalah tempat yang paling tepat untuk belajar Business English. Awalnya saya agak ragu karena akan belajar online tapi ternyata sangat efektif. Materi yang disampaikan cukup beragam dan terstruktur, penyampaian tutor juga sangat jelas. Suasana kelas juga sangat komunikatif yang membuat saya makin percaya diri. Sebelum kelas dimulai, tutornya biasanya mengulang kembali materi pelajaran di pertemuan sebelumnya. Les di INGGO, buat saya, adalah pengalaman dan kesempatan yang bagus!"
      person="Ayu Dewilestari Napitupulu"
      images={AyuDewilestariNapitupuluImages}
      programs="Business English"
    />
  </Col>
);

export const AfiyaMaritza = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Kelas TOEFL INGGO sangat bagus! Tutor saya sangat sabar dalam mengajar dan juga memberikan banyak pengetahuan baru bagi saya. Pengajaran tutor saya juga sangat interaktif sehingga saya semakin paham materi yang disampaikan."
      images={AfiyaMaritzaImages}
      programs="TOEFL"
      person="Afiya Maritza"
    />
  </Col>
);

export const FachriAkbar = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Belajar TOEFL di INGGO seru karena di setiap penyampaian materinya ada intermezzo berupa games atau fun fact jadi suasana kelas ngga membosankan walaupun secara daring. Materi dan tips-tips structure, listening, writing, dan reading yang disampaikan juga bermanfaat banget buat ngerjain soal-soal tes TOEFL."
      images={FachriAkbarImages}
      programs="TOEFL"
      person="Fachri Akbar"
    />
  </Col>
);

export const FandiAfianataDarmawan = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Kelas General English di INGGO sangat menyenangkan. Penyampaian materi tutor saya sangat bagus dan pastinya dia sangat sabar menghadapi aku yang banyak banget pertanyaannya. Setiap pertemuan juga sangat seru sehingga lesnya tidak berasa membosankan sama sekali."
      images={FandiAfianataDarmawanImages}
      programs="General English"
      person="Fandi Afianata Darmawan"
    />
  </Col>
);
export const MuhammadHafizhAsad = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Paket komplit belajar TOEFL benar-benar hanya ada di INGGO. Materinya sangat to the point, penyampaian tutornya asik banget untuk dan pengajarnya enak diajak diskusi. Pokoknya ga nyesel pernah belajar di INGGO karena ga ngebosenin sama sekali! "
      images={MuhammadHafizhAsadImages}
      programs="TOEFL"
      person="Muhammad Hafizh Asad"
    />
  </Col>
);

export const RifkaCharmelita = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Senang sekali bisa belajar TOEFL di INGGO. Tutorku sangat sabar menjawab pertanyaan-pertanyaanku dan selalu mendorongku untuk berbicara dalam bahasa Inggris walaupun kadang masih terbata-bata. Penyampaian materi juga dikemas dengan seru sehingga waktu belajar 2 jam tidak terasa."
      images={RifkaCharmelitaImages}
      programs="TOEFL"
      person="Rifka Charmelita"
    />
  </Col>
);

export const MutiaSekarDini = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Belajar kelas Business English di INGGO benar-benar membantu saya memahami istilah-istilah bisnis dalam Bahasa inggris yang sangat membantu perkembangan karir saya. Selain itu, saya juga belajar mengenai etika dalam dunia bisnis dan studi kasus yang relevan dengan pekerjaan saya. Tutor saya juga sangat mengerti kebutuhan saya dan saya juga diberi tambahan pelajaran mengenai basic English yang saya rasa masih kurang. Saya tidak pernah ragu merekomendasikan INGGO kepada teman-teman saya yang ingin belajr Business English."
      images={MutiaSekarDiniImages}
      programs="Business English"
      person="Mutia Sekar Dini"
    />
  </Col>
);

export const LodangJati = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Saya mengikuti kelas persiapan IELTS untuk persiapan beasiswa dan kuliah S2 saya. Saya sangat senang belajar di INGGO karena penyampaian tutor saya tentang strategi IELTS sangatlah jelas. Sebelumnya saya cukup berjuang untuk mendapatkan nilai 7 di Writing saya dan akhirnya saya berhasil mencapai target saya setelah persiapan di INGGO. Saya juga mempersiapkan aplikasi beasiswa dan review essay di INGGO.  Saat ini saya sudah menjadi penerima beasiswa bergengsi dan tanpa INGGO, perjalanan ini akan mustahil! Terima kasih, INGGO!"
      images={LodangJatiImages}
      programs="IELTS"
      person="Lodang Jati"
    />
  </Col>
);

export const SerlyKusumadewi = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Terima kasih banyak ya INGGO sudah bantu aku belajar dan mempersiapkan diri buat menghadapi ujian IELTS di tengah pandemi dan PPKM ini. Meski beberapa kali jadwal ujian IELTS ditunda karena PPKM, tutorku selalu menyemangati dan terus ngingetin apa yang perlu aku tingkatkan dan perbaiki. Alhasil setelah ujian, aku berhasil mencapai nilai overall score 7.5!"
      images={SerliKusumadewiImages}
      programs="IELTS"
      person="Serly Kusumadewi"
    />
  </Col>
);

export const KathyAiraSurono = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Akhirnya aku bisa mencapai overall score 7.5 setelah belajar IELTS dengan INGGO! Aku awalnya agak struggle dengan banyak aspek tapi setelah les di INGGO, aku jadi lebih paham tips dan triks yang penting. Aku banyak dikirimi Latihan dan catatan apa saja yang harus diperbaiki di akhir setiap sesi yang benar-benar sangat membantu. Thank you INGGO!"
      images={KathyAiraSuronoImages}
      programs="IELTS"
      person="Kathy Aira Surono"
    />
  </Col>
);

export const ThantowySyamsuddin = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Di percobaan pertama ujian IELTS, saya hanya mendapatkan 6 di Speaking. Tetapi setelah 1 bulan belajar intensif di INGGO, nilai speaking saya meningkat drastis ke 7.5, dengan overall score 7.5 juga. Tutor saya sangat membantu saya. Materinya sangat terstruktur dan sesuai dengan kebutuhan saya. Di setiap sesi, saya banyak mendapat masukan untuk menyiapkan saya untuk hari ujian nanti. Tutor saya sangat bagus dan saya berharap saya les di INGGO lebih awal."
      images={ThantowySyamsuddinImages}
      programs="IELTS"
      person="Thantowy Syamsuddin"
    />
  </Col>
);

export const SitiKarinThaliaMirza = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Setelah persiapan IELTS di INGGO, kemampuan  reading dan writing saya meningkat dan ketika ujian, saya dapat mengerjakan dengan lancar. Alhasil, saya mencapai overall score 7. Strategi yang diajarkan sangat jelas dan saya jadi lebih percaya diri ketika ujian. Thank you!"
      images={SitiKarinThaliaImages}
      programs="IELTS"
      person="Siti Karin Thalia Mirza"
    />
  </Col>
);

export const AnnisaWardhani = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Tutor Academic Writing saya di INGGO benar-benar sangat membantu saya di setiap sesi saya! Dia mengikuti kebutuhan saya dan selama berdiskusi mengenai tugas-tugas saya, dia selalu memberikan ide yang sangat berguna. Saya pertama kali belajar tentang cara mengkonstruksi ide, membuat pertanyaan untuk riset saya dan sebagainya. Setiap sesi sangat terstruktur dengan baik karena tutor saya selalu memberitahukan apa objektif kelas kita untuk sesi-sesi berikutnya. Saya benar-benar merasa puas dengan pengetahuan yang dibagikan oleh tutor saya. Makasih INGGO!"
      images={AnnisaRWardhaniImages}
      programs="Academic Writing"
      person="Annisa R Wardhani"
    />
  </Col>
);

export const AnnisaSriBaskara = () => (
  <Col md={4} xl={4} className="mb-4">
    <ExampleCardPersonBlue
      description="Perjalanan beasiswa saya tidak akan berhasil tanpa bantuan dari tutor INGGO. Saya pernah gagal beasiswa Chevening sekali ketika saya mencoba sendiri tapi dengan bantuan tutor tersebut, saya akhirnya mendapatkan beasiswa Chevening di tahun 2020. Tutor saya membantu proofread esai-esai saya dan saya juga mengikuti simulasi interview beasiswa dimana saya mendapatkan banyak tips berguna. Selain itu, saya juga mempersiapkan kelas IELTS saya di INGGO dan saya berhasil meningkatkan nilai Writing saya dari 5.5 ke 7! Terima kasih INGGO!"
      images={AnnisaSBaskaraImages}
      programs="IELTS"
      person="Annisa Sri Bakara"
    />
  </Col>
);
